import { render } from "./AnnouncementSender.vue?vue&type=template&id=a84bafd8&scoped=true"
import script from "./AnnouncementSender.vue?vue&type=script&lang=js"
export * from "./AnnouncementSender.vue?vue&type=script&lang=js"

import "./AnnouncementSender.vue?vue&type=style&index=0&id=a84bafd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a84bafd8"]])

export default __exports__